var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.966,
    height: 25.403,
    viewBox: "0 0 81.966 25.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.067,
    x2: 0.933,
    y1: 0.25,
    y2: 0.75,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd342e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#dc322d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#d92729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82327"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(-149.614 -652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rooamLogo-full-whiteText",
    transform: "translate(150.074 373.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M451.607,337.3c1.981,0,3.1,1.361,2.964,3.493l-.439,6.215H450.82l.378-5.414c.06-.8-.242-1.376-.983-1.376a1.38,1.38,0,0,0-1.3,1.013l-.408,5.777h-3.281l.378-5.414c.06-.8-.242-1.376-.983-1.376a1.366,1.366,0,0,0-1.3,1.013l-.408,5.777H439.6l.65-9.481h3.312l-.061.771a3.393,3.393,0,0,1,2.51-1,3.079,3.079,0,0,1,2.54,1.134A4.366,4.366,0,0,1,451.607,337.3Z",
    transform: "translate(-373.076 -50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M376.871,341.126c0-.076.015-.136.015-.2.06-.756.106-1.512.166-2.268.015-.121.045-.2.166-.227a7.538,7.538,0,0,1,2.556-.62,7.4,7.4,0,0,1,2.162.106,3.383,3.383,0,0,1,2.132,1.255,3.068,3.068,0,0,1,.575,1.739,5.866,5.866,0,0,1-.03.892c-.121,1.8-.242,3.6-.378,5.4,0,.076-.015.136-.015.212h-3.145c.015-.151.015-.272.03-.393a8.257,8.257,0,0,1-1.1.423,3.9,3.9,0,0,1-3.4-.529,2.555,2.555,0,0,1-.922-2.888,3.071,3.071,0,0,1,1.981-2.147,4.531,4.531,0,0,1,3.418-.015,3.825,3.825,0,0,1,.348.181,1.042,1.042,0,0,0-.348-1.164,1.922,1.922,0,0,0-1.074-.378,5.254,5.254,0,0,0-2.994.6A.2.2,0,0,0,376.871,341.126Zm2.994,4.264a1.927,1.927,0,0,0,1.059-.318.763.763,0,0,0,.091-1.164,1.885,1.885,0,0,0-1.951-.121.8.8,0,0,0-.151,1.346A1.515,1.515,0,0,0,379.865,345.39Z",
    transform: "translate(-318.725 -50.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M196.968,336.928l.076-1.028h-3.463l-.68,9.89h3.463l.378-5.429c.59-2.238,2.646-1.074,2.646-1.074l1.452-2.707A2.9,2.9,0,0,0,196.968,336.928Z",
    transform: "translate(-163.682 -48.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M244.114,347.02a4.315,4.315,0,0,1-4.506-4.96,5.087,5.087,0,0,1,5.187-4.96,4.308,4.308,0,0,1,4.506,4.96A5.059,5.059,0,0,1,244.114,347.02Zm.514-7.2c-1.013,0-1.648.938-1.739,2.238s.408,2.223,1.437,2.223,1.663-.907,1.754-2.223C246.155,340.744,245.671,339.822,244.628,339.822Z",
    transform: "translate(-203.312 -49.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M312.414,347.02a4.315,4.315,0,0,1-4.506-4.96,5.087,5.087,0,0,1,5.187-4.96,4.308,4.308,0,0,1,4.506,4.96A5.059,5.059,0,0,1,312.414,347.02Zm.514-7.2c-1.013,0-1.648.938-1.739,2.238s.408,2.223,1.437,2.223,1.663-.907,1.754-2.223C314.455,340.744,313.971,339.822,312.928,339.822Z",
    transform: "translate(-261.284 -49.831)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 13.254,
    cy: 12.701,
    rx: 13.254,
    ry: 12.701,
    transform: "translate(-0.46 278.469)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(2.694 281.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M27.632,295.9A10.133,10.133,0,0,0,17.5,305.941v.106h0A10.147,10.147,0,1,0,27.632,295.9Zm0,2.026a8.073,8.073,0,0,1,6.094,2.767,5.873,5.873,0,0,0-1.558-.227,5.565,5.565,0,0,0-4.567,2.389,5.548,5.548,0,0,0-6.079-2.178A8.219,8.219,0,0,1,27.632,297.926Zm0,16.226a8.116,8.116,0,0,1-8.105-8.105c0-.212.015-.423.03-.635a3.559,3.559,0,0,1,7.062.62l-.272,3.024,1.285.907,1.285-.907-.272-3.024a3.554,3.554,0,1,1,7.107,0h0A8.132,8.132,0,0,1,27.632,314.152Z",
    transform: "translate(-17.5 -295.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M104.245,350.7a1.852,1.852,0,0,0-1.845,1.845h0a1.845,1.845,0,1,0,3.69,0h0A1.852,1.852,0,0,0,104.245,350.7Z",
    transform: "translate(-89.562 -342.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M43.845,350.7A1.852,1.852,0,0,0,42,352.545h0a1.845,1.845,0,1,0,3.69,0h0A1.843,1.843,0,0,0,43.845,350.7Z",
    transform: "translate(-38.295 -342.413)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b469f461f742ed08e248cbb370421941.svg";
export { ForwardRef as ReactComponent };